export const SHOW_SNACKBAR = 'waitrose/snackbar/SHOW_SNACKBAR' as const;
export const VIEWED_SNACKBAR = 'waitrose/snackbar/VIEWED_SNACKBAR' as const;
export const RESET_SNACKBAR = 'waitrose/snackbar/RESET_SNACKBAR' as const;
export const REMOVE_VIEWED_IDS = 'waitrose/snackbar/REMOVE_VIEWED_IDS' as const;
